/* @HEADER
 * @version 1.1.889 | 2026-10-24
 * @purpose The project list a link is judged against: the app's own getAllProjects() with each project's organisation read as the app reads it, never the databases on the device (ZVX-DEV-8263, R9 cases 1 and 4).
 * @sidecar navLinkProjects.ts.header.md
 * @layer app | @hex _none_ | @ctx routing
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-8263, ZVX-DEV-7134

/**
 * The list of projects a link is judged against (`NavLinkPorts.projects`, ZVX-4464, R9 cases 1 and 4): the SAME list the app
 * shows to this account -- `getAllProjects()` -- and nothing wider. It drops a project proven foreign to the account
 * (another account's leftover on a shared device, or one this account was refused) and a project mid-tombstone for the
 * person who placed it. The databases on the device are not consulted: a device keeps what it once received, and that is
 * not a right.
 *
 * `organisationId` is the project's declared organisation, read the way the rest of the app reads it
 * (`resolveProjectOrgId`), with the account's personal workspace as the fallback for a personal project.
 */

import { getAllProjects } from '../lib/projectStore.ts';
import { resolvePersonalWorkspaceId, resolveProjectOrgId } from '../lib/projectOrgScope.ts';
import { readAccountIdentity } from '../features/account/accountIdentity.ts';
import type { LinkProject } from './navLinkResolve.ts';

export function listLinkProjects(): LinkProject[] {
  const personalWorkspaceId = resolvePersonalWorkspaceId(readAccountIdentity().workspaces);
  return getAllProjects().map((project) => ({
    id: project.id,
    serverProjectId: project.serverProjectId ?? null,
    organisationId: resolveProjectOrgId(project, personalWorkspaceId) ?? null,
  }));
}
